import { Controller } from "@hotwired/stimulus"
import IMask, { InputMask } from "imask"

export default class extends Controller {
  static values = {
    hideUnit: Boolean
  }
  mask: InputMask;
  declare readonly hideUnitValue?: boolean;

  connect() {
    const input = this.element as HTMLInputElement
    const maskOptions = {
      mask: `${this.hideUnitValue ? '' : '$'}num`,
      blocks: {
        num: {
          mask: Number,
          scale: 2,
          thousandsSeparator: ',',
          padFractionalZeros: true,
          normalizeZeros: true,
          radix: '.',
          mapToRadix: [".", ","],
        }
      }
    }
    this.mask = IMask(input, maskOptions)
  }
}
